<template>
  <div ref="mainInfo" class="main-info">
    <div class="main-info__wrapper">
      <ButtonBurger />
      <div class="main-info__catalog-menu">
        <ButtonCatalog />
        <RenderCacheable
          :max-age="86400"
          :cache-key="[getUserLanguage.name, getHash].join('--')"
        >
          <ModalCatalog
            class="main-info__catalog"
            :style="{
              '--bottom':
                heightCatalog > bottomValue - heightHeader
                  ? -(bottomValue - heightHeader) + 'px'
                  : -heightCatalog + 'px',
            }"
            @height-content="getHeightContent"
          />
        </RenderCacheable>
      </div>
      <Logo class="main-info__logo" />
      <Search />
      <ButtonLanguage />
      <NavigationMenu />
    </div>
  </div>
</template>

<script setup>
import ButtonBurger from "~~/modules/header/components/UI/ButtonBurger.vue";
import ButtonCatalog from "~~/modules/header/components/UI/ButtonCatalog.vue";
import Logo from "~~/modules/header/components/UI/Logo.vue";
import Search from "~/modules/header/components/UI/Search.vue";
import NavigationMenu from "~~/modules/header/sections/NavigationMenu.vue";
import ModalCatalog from "~~/modules/header/sections/ModalCatalog.vue";
import { addScopedEventListener } from "~~/utils/eventListener";
import ButtonLanguage from "~/modules/header/components/UI/ButtonLanguage.vue";
import { useLanguageStore } from "~/store/languageStore";
import { useCategoriesStore } from "~/store/categoriesStore";

const props = defineProps({
  heightHeader: { type: Number, required: false },
});

const emits = defineEmits(["getHeightMainInfo"]);

const languageStore = useLanguageStore();
const { getUserLanguage } = storeToRefs(languageStore);
const categoryStore = useCategoriesStore();
const { getHash } = storeToRefs(categoryStore);

const mainInfo = ref(null);

const heightCatalog = ref(0);
const bottomValue = ref(0);

function getPosition() {
  emits("getHeightMainInfo", mainInfo.value.offsetHeight);
  getPositionButton();
}

function getPositionButton() {
  bottomValue.value = document.documentElement.clientHeight;
}

function getHeightContent(value) {
  heightCatalog.value = value;
}

onMounted(() => {
  getPosition();
  addScopedEventListener(window, "resize", getPosition);
});
</script>

<style lang="scss" scoped>
.main-info {
  background-color: var(--color-green-black);

  &__wrapper {
    @extend %width-main;

    @include flex-container(row, space-between, center);

    position: relative;

    margin: 0 auto;
    gap: 16px;

    @include mobile {
      gap: 8px;
    }
  }

  &__catalog-menu {
    @include bigMobile {
      display: none;
    }
  }

  &__catalog {
    --bottom: 0;

    position: absolute;
    top: 109%;
    bottom: var(--bottom);
    left: 0;
    z-index: 501;

    box-shadow: 0 4px 7px rgba(0, 0, 0, 0.25);
  }

  &__logo {
    width: 48px;
    height: 48px;
    @include flex-container(row, center, center);

    @include bigMobile {
      display: none;
    }
  }
}
</style>
